
import React, { useState } from 'react';
import SecondNav from "../Navbar/SecondNav";
import TopNavbar from "../Navbar/TopNavbar";
import Footer from './Footer';

function Warranty() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    orderNumber: '',
    issue: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Warranty claim submitted! We will contact you soon.');
    setFormData({ name: '', email: '', orderNumber: '', issue: '' });
  };

  return (
    <div
      className="home-page"
      style={{
        width: "100%",
        minHeight: "100vh",
        backgroundImage: "url('https://media.istockphoto.com/id/914838506/photo/blue-sports-car-driving-on-urban-scene.jpg?s=612x612&w=0&k=20&c=UwdMAVPQxnq-yOeI4Wnjwsf1F54TXfBFbcCygm_S_zQ=')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <div style={{ backgroundColor: "rgba(6, 6, 6, 0)", minHeight: "100vh" }}>
        <TopNavbar />
        <SecondNav />

        <div style={{ padding: '40px', maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '2.5rem', textAlign: 'center', marginBottom: '60px', color: '#0d47a1' }}>
            Warranty Information
          </h1>

          {/* Warranty Overview */}
          <section
            style={{
              marginBottom: '40px',
              padding: '30px',
              background: 'linear-gradient(135deg, #0d47a1, #1976d2)',
              borderRadius: '12px',
              color: '#fff',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
              fontFamily: "'Segoe UI', sans-serif",
            }}
          >
            <h2
              style={{
                fontSize: '2rem',
                marginBottom: '20px',
                color: '#ffffff',
                borderBottom: '2px solid #BBDEFB',
                paddingBottom: '10px',
                textShadow: '1px 1px 4px rgba(0,0,0,0.4)',
              }}
            >
              Our Warranty Commitment
            </h2>

            <p
              style={{
                color: '#E3F2FD',
                lineHeight: '1.8',
                marginBottom: '15px',
                fontSize: '1.1rem',
              }}
            >
              We stand behind the quality of our products. All our products come with a{' '}
              <strong style={{ color: '#fff' }}>1-year limited warranty</strong> covering
              defects in materials and workmanship under normal use.
            </p>

            <p
              style={{
                color: '#E3F2FD',
                lineHeight: '1.8',
                fontSize: '1.1rem',
              }}
            >
              If you encounter any issues with your product, please review the warranty
              terms below and submit a claim through our contact form.
            </p>
          </section>

          {/* Warranty Details */}
          <section
            style={{
              marginBottom: '40px',
              padding: '30px',
              background: 'linear-gradient(135deg, #0d47a1, #1976d2)',
              borderRadius: '12px',
              color: '#fff',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
            }}
          >
            <h2
              style={{
                fontSize: '2rem',
                marginBottom: '20px',
                color: '#ffffff',
                borderBottom: '2px solid #fff',
                paddingBottom: '10px',
                textShadow: '1px 1px 4px rgba(0,0,0,0.5)',
              }}
            >
              Warranty Terms
            </h2>

            <ul style={{ lineHeight: '1.8', paddingLeft: '25px' }}>
              <li style={{ marginBottom: '12px' }}>
                <strong style={{ color: '#BBDEFB' }}>Duration:</strong>{' '}
                <span style={{ fontWeight: 'bold', color: '#fff' }}>1 year</span> from the date of purchase.
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong style={{ color: '#BBDEFB' }}>Coverage:</strong>{' '}
                Covers manufacturing defects and hardware malfunctions under normal use.
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong style={{ color: '#BBDEFB' }}>Exclusions:</strong>{' '}
                Damage due to misuse, accidents, unauthorized repairs, or normal wear and tear is not covered.
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong style={{ color: '#BBDEFB' }}>Process:</strong>{' '}
                Submit a claim via the form below with your order details and issue description.
              </li>
            </ul>
          </section>

          {/* Contact Form */}
          <section
            style={{
              marginTop: '40px',
              marginBottom: '60px',
              padding: '30px',
              backgroundColor: '#f4f6fc',
              borderRadius: '12px',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
              fontFamily: "'Segoe UI', sans-serif",
            }}
          >
            <h2
              style={{
                fontSize: '2rem',
                marginBottom: '25px',
                color: '#0d47a1',
                textShadow: '0 1px 3px rgba(0,0,0,0.1)',
                borderBottom: '2px solid #90caf9',
                paddingBottom: '10px',
              }}
            >
              Submit a Warranty Claim
            </h2>

            <div
              style={{
                background: '#ffffff',
                padding: '30px',
                borderRadius: '10px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              }}
            >
              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                {/* Name */}
                <div>
                  <label htmlFor="name" style={{ display: 'block', marginBottom: '8px', color: '#0d47a1', fontWeight: 'bold' }}>
                    Full Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '12px',
                      borderRadius: '6px',
                      border: '1px solid #ccc',
                      fontSize: '1rem',
                    }}
                  />
                </div>

                {/* Email */}
                <div>
                  <label htmlFor="email" style={{ display: 'block', marginBottom: '8px', color: '#0d47a1', fontWeight: 'bold' }}>
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '12px',
                      borderRadius: '6px',
                      border: '1px solid #ccc',
                      fontSize: '1rem',
                    }}
                  />
                </div>

                {/* Order Number */}
                <div>
                  <label htmlFor="orderNumber" style={{ display: 'block', marginBottom: '8px', color: '#0d47a1', fontWeight: 'bold' }}>
                    Order Number
                  </label>
                  <input
                    type="text"
                    id="orderNumber"
                    name="orderNumber"
                    value={formData.orderNumber}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '12px',
                      borderRadius: '6px',
                      border: '1px solid #ccc',
                      fontSize: '1rem',
                    }}
                  />
                </div>

                {/* Issue */}
                <div>
                  <label htmlFor="issue" style={{ display: 'block', marginBottom: '8px', color: '#0d47a1', fontWeight: 'bold' }}>
                    Describe the Issue
                  </label>
                  <textarea
                    id="issue"
                    name="issue"
                    value={formData.issue}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '12px',
                      borderRadius: '6px',
                      border: '1px solid #ccc',
                      fontSize: '1rem',
                      minHeight: '120px',
                    }}
                  />
                </div>

                {/* Submit */}
                <button
                  type="submit"
                  style={{
                    background: '#1565c0',
                    color: '#ffffff',
                    padding: '12px 24px',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    width: 'fit-content',
                  }}
                >
                  Submit Claim
                </button>
              </form>
            </div>
          </section>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Warranty;
